module.exports = __webpack_public_path__ + "static/media/6-8.9ed00b41.mp3";